import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { QuestionTypes } from '../../../../constants/QuestionTypes';
import { getAnswersWithSkip, removeAnswer } from '../../../../services/formService';
import SkipLogic from './Skip_Logic';
import { TextField } from '@material-ui/core';
import QAFooter from "./QAFooter";

class TypeDropdown extends Component {
	constructor(props) {
		super(props);
		const { Question_ID, Widget_ID } = this.props;
		this.state = {
			Allow_Multiple_Selection: false,
			Question_ID,
			Question_Type_ID: QuestionTypes.Dropdown,
			Question_Answers: [],
			Widget_ID,
			show: false,
			origStates: {
				Allow_Multiple_Selection: false,
				Question_Answers: []
			}
		};
	}

	async componentDidMount() {
		let { data: Question_Answers } = await getAnswersWithSkip(this.state.Question_ID);
		this.setState({
			Question_Answers,
			Allow_Multiple_Selection: this.props.allowMultipleSelection,
			origStates: {
				Question_Answers: JSON.parse(JSON.stringify(Question_Answers)),
				Allow_Multiple_Selection: this.props.allowMultipleSelection
			}
		});

		// disable re-map responses if this is a newly created widget that has not been saved yet
		if (Question_Answers.length === 0) this.props.setRemapResponses(false);
	}

	handleSave = async () => {
		const { Question_Answers } = this.state;

		const Question_ID = await this.props.onSave(Question_Answers);
		this.setState({
			Question_ID,
			origStates: {
				Question_Answers: JSON.parse(JSON.stringify(Question_Answers)),
				Allow_Multiple_Selection: this.state.Allow_Multiple_Selection
			}
		});

		// const Question_Answers = this.parseToSave();
		// const{onSuccessfulSave} = this.props;
		// let basicInfo = this.props.onSave();
		// const{Question_Text} = basicInfo;
		// const { data } = await updateQuestion(Question_Text,Question_Answers, {
		// 	...this.state,
		// 	...basicInfo,
		// });

		// if (typeof data === 'string') {
		// 	toast.error(data);
		//   return 0;
		// } else {
		// 	toast.success('Saved.');
		//   const Question_ID = data.split(":").pop();
		//   this.setState({ Question_ID });
		//   this.setState({ canChangeType: false });
		//   toast.success("Question saved.");
		//   return Question_ID;

		// }
	};

	handleRemove = () => {
		this.props.onRemove();
	};

	handleAnswerChange = (text, index) => {
		const Question_Answers = [...this.state.Question_Answers];
		Question_Answers[index]['Answer_Text'] = text;
		this.setState({ Question_Answers });
	};

	handleAnswerRemove = async (index) => {
		const answer = this.state.Question_Answers[index];
		const { data } = await removeAnswer(answer.Answer_ID);
		if (data.includes('Done')) {
			const Question_Answers = [...this.state.Question_Answers];
			Question_Answers.splice(index, 1);
			this.setState({ Question_Answers });
			toast.success('Answer removed');
		} else {
			toast.error(data);
		}
	};

	handleAnswerAdd = () => {
		const Question_Answers = [...this.state.Question_Answers, { Answer_ID: 0, Answer_Text: '', SkipLogic: [] }];
		this.setState({ Question_Answers });
	};

	handleComplexQuestionType = async (Allow_Multiple_Selection) => {
		const { onMultipleSelection } = this.props;
		onMultipleSelection(Allow_Multiple_Selection);
		this.setState({ Allow_Multiple_Selection });
	};

	handleShow = () => {
		this.setState({ show: true });
	};

	handleClose = () => {
		this.setState({ show: false });
	};

	handleSelection = (idx, selected) => {
		let Question_Answers = [...this.state.Question_Answers];
		Question_Answers[idx].SkipLogic = selected;
		this.setState({ Question_Answers });
	};

	/**
	 * Allow re-mapping responses if answers and multiple/single selection have NOT been changed
	 * from what is currently saved.
	 * @returns {boolean} True if allowed, False otherwise
	 */
	verifyRemapResponses = () => {
		const origStates = this.state.origStates;

		if (origStates.Allow_Multiple_Selection !== this.state.Allow_Multiple_Selection)
			return false;

		const Question_Answers = this.state.Question_Answers;
		if (origStates.Question_Answers.length !== Question_Answers.length) return false;
		for (let i = 0; i < Question_Answers.length; i++) {
			if (origStates.Question_Answers[i].Answer_Text !== Question_Answers[i].Answer_Text)
				return false;
		}
		return true;
	}
	render() {
		const { Question_ID } = this.state;
		let { Question_Answers } = this.state;

		return (
			<React.Fragment>
				<div>
					<div>
						<div className='form-check form-check-inline'>
							<input
								type='radio'
								className='form-check-input'
								id={Question_ID + 'single_selection'}
								name={Question_ID + 'dropdownType'}
								value='single'
								checked={!this.state.Allow_Multiple_Selection}
								onChange={(e) => this.handleComplexQuestionType(false)}
							/>
							<label htmlFor='single_selection' className='form-check-label'>
								Single selection
							</label>
						</div>

						<div className='form-check form-check-inline'>
							<input
								type='radio'
								className='form-check-input'
								id={Question_ID + 'multiple_selection'}
								name={Question_ID + 'dropdownType'}
								value='multiple'
								checked={this.state.Allow_Multiple_Selection}
								onChange={(e) => this.handleComplexQuestionType(true)}
							/>
							<label htmlFor='multiple_selection' className='form-check-label'>
								Allow multiple selection
							</label>
						</div>
					</div>
					<label>Dropdown Items</label>
					{Question_Answers.map((row, idx) => {
						return (
							<div className='form-row'  key={Question_ID + 'dropdown' + idx}>
								<div className='form-group col-md-1 text-center'>{idx + 1}.</div>
								<div className='form-group col-md-10'>
									<TextField
										fullWidth
										value={row.Answer_Text}
										variant='outlined'
										onChange={(e) => this.handleAnswerChange(e.target.value, idx)}
									/>
								</div>
							</div>
						);
					})}
					<div className='dropdown-divider'></div>
					<div className='text-center mt-1'>
						<button className='btn btn-outline-primary btn-icon btn-sm' onClick={this.handleAnswerAdd}>
							<Icon.Plus size={18} />
						</button>
					</div>
				</div>

				{/* HIDE SKIP LOGIC
				<div>
					<div className='float-left'>
						<button className='btn btn-outline-dark' onClick={this.handleShow}>
							Skip Logic
						</button>

						<Modal show={this.state.show} onHide={this.handleClose} id='skip_logic_modal'>
							<Modal.Header closeButton>
								<Modal.Title>Skip Logic Editor</Modal.Title>
							</Modal.Header>

							<Modal.Body>
								<SkipLogic Widget_ID={this.props.Widget_ID} Answers={Question_Answers} onClose={this.handleClose} />
							</Modal.Body>

							<Modal.Footer>
								<button className='btn btn-secondary btn-sm' onClick={this.handleClose}>
									Close
								</button>
							</Modal.Footer>
						</Modal>
					</div>
				</div>
				*/}
				<QAFooter Widget_ID={this.props.Widget_ID}
						  handleSave={this.handleSave}
						  handleRemove={this.handleRemove}
						  showRemapResponses={true}
						  remapResponses={this.props.remapResponses}
						  setRemapResponses={this.props.setRemapResponses}
						  verifyRemapResponses={this.verifyRemapResponses}/>
			</React.Fragment>
		);
	}
}

export default TypeDropdown;
